import { Stack } from '@mui/material';
import {
  InstallationsListSection,
  MilestoneDetailCard,
  MilestoneHistoryCard
} from 'modules/components';

import React from 'react';
import { useParams } from 'react-router-dom';
import * as ds from './dataService';


export type ProjectMilestoneDetailSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ProjectMilestoneDetailSectionProps) => {
  const params = useParams();

  ds.useQuery(params.milestoneId ?? '');

  return (
    <Stack
      direction='column'
      gap='1.5rem'
    >
      <Stack
        direction='row'
        justifyContent='space-between'
        columnGap='1.5rem'
      >
        {/* LEFT */}
        <Stack
          direction='column'
          rowGap='1.25rem'
          flex='1 1 0'
        >
          <MilestoneDetailCard.FC />
        </Stack>

        {/* RIGHT */}
        <Stack
          direction='column'
          rowGap='1.25rem'
          flex='1 1 0'
        >
          <MilestoneHistoryCard.FC />
        </Stack>

      </Stack>



      <InstallationsListSection.FC />


    </Stack>
  );
};
